import { customDateRanges, getDateObject } from "app/popleads/app/functions/util";
import { TooltipOverlay } from "app/popleads/components/TooltipOverlay";
import CustomDrawer, { DrawerBody, DrawerContent, DrawerHeader } from "app/popleads/components/drawer/CustomDrawer";
import useDisclosure from "app/popleads/hooks/useDisclosure";
import React from "react";
import { DateRangePicker } from "react-date-range";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../popleads/assets/css/design_3.0/CustomDatePicker.module.scss";
import { actions } from "app/popleads/modules/accounts/redux/accountsRedux";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import moment from "moment";

const PartnerFilterDrawer = () => {
    const { isOpen, onClose, onToggle } = useDisclosure();

    const { partnerSelectedDate } = useSelector((state) => state.accounts);
    const dispatch = useDispatch();

    return (
        <>
            <TooltipOverlay placement="bottom" tooltip="Filters">
                <ButtonWithText icon={"filter"} buttonStyle="selectedOption" variant="primary" onClick={onToggle} />
            </TooltipOverlay>
            <CustomDrawer position="right" size="md" open={isOpen} onClose={onClose}>
                <DrawerContent>
                    <DrawerHeader onClose={onClose} sx={{ border: "none" }}>
                        Filters
                    </DrawerHeader>
                    <DrawerBody>
                        <div className="secondary-color font-weight-bold mt-4 mb-2">Filter by Date</div>
                        <DateRangePicker
                            className={styles.rdrDateRangePickerWrapper}
                            ranges={[partnerSelectedDate]}
                            staticRanges={customDateRanges(new Date(null), new Date())}
                            onChange={(item) => {
                                const date = getDateObject(item.selection);
                                const newDate = {
                                    ...date,
                                    endDate: moment(date.endDate)
                                        .endOf("day")
                                        .toDate(),
                                };
                                dispatch(actions.setPartnerSelectedDate(newDate));
                                // DOM manipulation to highlight "All Time"
                                const range = document.querySelector(".rdrStaticRanges")?.firstElementChild;
                                if (range && !item.selection.startDate) {
                                    range.classList.add("rdrStaticRangeSelected");
                                } else {
                                    range.classList.remove("rdrStaticRangeSelected");
                                }
                            }}
                            inputRanges={[]}
                            direction="vertical"
                        />
                    </DrawerBody>
                </DrawerContent>
            </CustomDrawer>
        </>
    );
};

export default PartnerFilterDrawer;
